import axios from "axios";
import AppConstants from "../../constants/AppConstants";

const API = axios.create({ baseURL: AppConstants.baseURL });

//====================================================signup flow =================================================/////

export const signup = (formData) => API.post("/authclick/signup", formData); //======> signup

//====================================================login flow =================================================/////

export const loginWithPassword = (formData) =>
  API.post("/authclick/login", formData); //======> login with password

//=====================================userProfile process===============================//

export const getUserProfile = () => API.get("/authclick/profile");

//====================================================forgot passowrd flow =================================================/////
export const changePassword = (formData) =>
  API.post("/authclick/changepassword", formData);

// module permisiion======================================================================================================

export const modulePermissions = (formData) =>
  API.post("/authclick/addmodulepermission", formData);

export const modulesByUserData = () => API.get("/authclick/modulesbyuser");

export const addRolesModules = (formData) =>
  API.post("/authclick/addroles", formData);

export const showRoles = (formData) =>
  API.get("/authclick/showroles", formData);

export const showuserTypeModulesData = (formData) =>
  API.get("/authclick/showmoduleusertype", formData);

export const getAllPanelUsers = (formData) =>
  API.get("/authclick/allpanelusers", formData);

export const userManagementRolesData = (formData) =>
  API.post("/authclick/userallpermission", formData);

//================================== Add New Role ==================================//
export const addNewRole = (formData) =>
  API.post("/authclick/addroles", formData);
export const activeRole = (formData) =>
  API.post("/authclick/deleterole", formData);

export const updatePanelUser = (formData) =>
  API.post("/authclick/updatepanelusers", formData);

export const addNewModules = (formData) =>
  API.post("/authclick/newmodules", formData);

export const showAllModules = () => API.get("/authclick/showallmodules");

export const activateModules = (formData) =>
  API.post("/authclick/activemodules", formData);
